import type { DRM } from '@jwp/ott-common/types/playlist';
import type shaka from 'shaka-player';

export function buildDrmConfig(drm: DRM | undefined): shaka.extern.DrmConfiguration | null {
  if (!drm) return null;
  const servers: Record<string, string> = {};
  if (drm.widevine?.url) servers['com.widevine.alpha'] = drm.widevine.url;
  if (drm.playready?.url) servers['com.microsoft.playready'] = drm.playready.url;
  if (drm.fairplay?.processSpcUrl) servers['com.apple.fps'] = drm.fairplay.processSpcUrl;
  if (!Object.keys(servers).length) return null;
  return {
    servers,
    ...(drm.fairplay?.certificateUrl
      ? { advanced: { 'com.apple.fps': { serverCertificateUri: drm.fairplay.certificateUrl } } }
      : {}),
  } as unknown as shaka.extern.DrmConfiguration;
}
